import { transparentize as t } from "polished";
import mode from "./mode";
import variant from "./variant";
import { transparentized } from "../theme/colors";
export const transparentizeColor = variant("mode", "color", transparentized);
export const transparentizedDefaultColor = mode(transparentized.default);
export const transparentizedPrimaryColor = mode(transparentized.primary);
export const transparentizedPositiveColor = mode(transparentized.positive);
export const transparentizedNegativeColor = mode(transparentized.negative);
export default function transparentize(props, value = 0.76) {
  return transparentized[props.color] ? transparentizeColor(props) : t(value, props.color);
}
//# sourceMappingURL=transparentize.js.map